<dt-modal-content [showFooter]="true" [flexContent]="true" size="small" (closeClick)="discard()" [dtOverlayProgress]="loading">
  <ng-template #title>
    @if (createNew) {
      <ng-container i18n>KLUGentscheiden Projekt erstellen</ng-container>
    } @else {
      <ng-container i18n>KLUGentscheiden Projekt bearbeiten</ng-container>
    }
  </ng-template>

  <ng-template #content>
    <form [formGroup]="projectFormGroup">
      <fieldset [disabled]="loading">
        <mat-form-field>
          <mat-label i18n>Token</mat-label>
          <input matInput formControlName="token" />
          @if (projectFormGroup.hasError('duplicateToken', 'token')) {
            <mat-error i18n>Dieser Token wird bereits verwendet</mat-error>
          }
          @if (projectFormGroup.hasError('required', 'token')) {
            <mat-error i18n>Der Token darf nicht leer sein</mat-error>
          }
        </mat-form-field>
        <mat-slide-toggle formControlName="readonly" i18n>Schreibgeschützt</mat-slide-toggle>
        <mat-slide-toggle formControlName="isOfficial" i18n>Offizielles KLUGentscheiden Projekt</mat-slide-toggle>
      </fieldset>
    </form>
  </ng-template>

  <ng-template #footer>
    <button mat-raised-button color="primary" i18n (click)="save()" [disabled]="projectFormGroup.invalid || loading">Speichern</button>
    <button mat-stroked-button i18n (click)="discard()" [disabled]="loading">Verwerfen</button>
    @if (!createNew) {
      <button mat-stroked-button color="warn" i18n (click)="delete()" [disabled]="loading">Löschen</button>
    }
  </ng-template>
</dt-modal-content>
